<template>
  <div class="">
    <template v-if="canDelete">
      <div>
        <p>Are you sure you want to delete this post?</p>
        <p class="text-sm italic">This can't be undone</p>
      </div>

      <div class="flex justify-end mt-8">
        <button
          v-if="!formBusy"
          type="button"
          class="flex gap-x-2 justify-between items-center py-3 px-4 w-full text-sm font-semibold text-center text-white from-red-500 to-purple-800 rounded-lg border border-transparent transition ease-in-out bg-linear-to-r hover:from-red-600 hover:to-purple-400 disabled:opacity-50 disabled:pointer-events-none"
          @click.prevent="deletePost">
          Delete <fa-icon icon="trash" class="fa-fw" />
        </button>

        <button
          v-else
          type="button"
          class="flex gap-x-2 justify-between items-center py-3 px-4 w-full text-sm font-semibold text-center text-white from-red-500 to-purple-800 rounded-lg border border-transparent transition ease-in-out bg-linear-to-r hover:from-red-600 hover:to-purple-400 disabled:opacity-50 disabled:pointer-events-none">
          Deleting..
          <fa-icon icon="spinner-third" class="fa-spin fa-fw" />
        </button>

        <div
          v-if="formError"
          class="p-2 my-2 text-xs bg-red-500 rounded-sm cursor-pointer hover:bg-red-600"
          @click.prevent="clearFormError">
          Error deleting post: {{ formError }}
        </div>
      </div>
    </template>
    <template v-else>
      <p>Sorry, you cannot delete this post.</p>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStoreAuth } from '@/stores/storeAuth'
import { useStoreClubs } from '@/stores/storeClubs'

const formBusy = ref(false)
const formError = ref(null)
const storeAuth = useStoreAuth()
const storeClubs = useStoreClubs()

const props = defineProps({
  post: Object,
  clubSlug: String
})

const emit = defineEmits({
  success: null,
  delete: null
})

const canDelete = computed(() => {
  if (!props.post || !storeAuth.user) return false
  // User can delete if they are the author, or an admin/owner
  const isAuthor = props.post.user_id === storeAuth.user.id
  // Note: We'd need to pass userRole as a prop if we want to check admin status here
  // For now, we'll rely on the backend to enforce permissions
  return isAuthor
})

const deletePost = async () => {
  if (!props.post || !props.clubSlug) return

  formBusy.value = true
  formError.value = null

  const success = await storeClubs.deletePost(props.clubSlug, props.post.id)

  if (!success) {
    formError.value = storeClubs.error || 'Failed to delete post'
    formBusy.value = false
    return
  } else {
    formBusy.value = false
    emit('delete', props.post)
    emit('success')
  }
}

const clearFormError = () => {
  formError.value = null
}
</script>
